module.exports = __webpack_public_path__ + "static/media/image_15.809ab871.png";